"use client"

import { motion } from "framer-motion"
import { FaUser, FaEnvelope, FaLock, FaGoogle, FaInfoCircle } from "react-icons/fa"
import { useState } from "react"

const inputVariants = {
  focus: { scale: 1.02, transition: { duration: 0.2 } },
}

const OwnerRegistrationForm = ({ formData, handleChange, handleNextStep, login, user, error }) => {
  const [showPassword, setShowPassword] = useState(false)

  // Función para manejar cambios en los campos del propietario
  const handleOwnerChange = (e) => {
    const { name, value } = e.target
    handleChange({
      target: {
        name: `owner.${name}`,
        value,
      },
    })
  }

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-white rounded-xl shadow-xl overflow-hidden"
    >
      <div className="bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] py-4 px-6">
        <h3 className="text-white text-xl font-semibold">Información del Propietario</h3>
        <p className="text-blue-100 text-sm">Paso 1 de 3</p>
      </div>

      <form id="registrationForm" onSubmit={handleNextStep} className="p-6 space-y-4">
        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="username" className="block mb-1 text-sm font-medium text-gray-700">
            Nombre de Usuario
          </label>
          <div className="relative">
            <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleOwnerChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="Ingrese su nombre de usuario"
            />
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="email" className="block mb-1 text-sm font-medium text-gray-700">
            Correo Electrónico
          </label>
          <div className="relative">
            <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleOwnerChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="ejemplo@correo.com"
            />
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="password" className="block mb-1 text-sm font-medium text-gray-700">
            Contraseña
          </label>
          <div className="relative">
            <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleOwnerChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="Ingrese su contraseña"
              minLength={6}
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Ocultar" : "Mostrar"}
            </button>
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="about_me" className="block mb-1 text-sm font-medium text-gray-700">
            Acerca de mí
          </label>
          <div className="relative">
            <FaInfoCircle className="absolute left-3 top-3 text-gray-400" />
            <textarea
              id="about_me"
              name="about_me"
              value={formData.about_me}
              onChange={handleOwnerChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              rows={3}
              placeholder="Breve descripción sobre usted y su experiencia profesional"
            ></textarea>
          </div>
        </motion.div>

        <div className="pt-4">
          <motion.button
            type="submit"
            className="w-full bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-indigo-800 transition duration-300 font-medium"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Continuar
          </motion.button>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-3">O regístrate con:</p>
          <motion.button
            type="button"
            onClick={login}
            className="w-full bg-white text-gray-700 border border-gray-300 py-3 px-4 rounded-lg hover:bg-gray-50 transition duration-300 flex items-center justify-center shadow-sm"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FaGoogle className="mr-2 text-red-500" />
            Registrarse con Google
          </motion.button>
          {error && <p className="text-red-500 text-sm mt-2 bg-red-50 p-2 rounded-lg">{error}</p>}
          {user && <p className="text-green-500 text-sm mt-2 bg-green-50 p-2 rounded-lg">¡Bienvenido, {user.name}!</p>}
        </div>
      </form>
    </motion.div>
  )
}

export default OwnerRegistrationForm

